/**
 * 极简 toast：无依赖、全局单例、3 秒自动消失，视觉与项目其它 tailwind
 * 主题保持一致。避免为一点反馈引入 sonner 之类的包。
 */

import { useEffect, useState } from "react";
import { create } from "zustand";

type Kind = "info" | "success" | "error";

interface ToastMsg {
  id: number;
  kind: Kind;
  text: string;
}

interface ToastStore {
  items: ToastMsg[];
  push: (kind: Kind, text: string) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

const useToastStore = create<ToastStore>((set) => ({
  items: [],
  push: (kind, text) => {
    const id = nextId++;
    set((s) => ({ items: [...s.items, { id, kind, text }] }));
    setTimeout(() => {
      set((s) => ({ items: s.items.filter((i) => i.id !== id) }));
    }, 3000);
  },
  dismiss: (id) =>
    set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
}));

export const toast = {
  info: (t: string) => useToastStore.getState().push("info", t),
  success: (t: string) => useToastStore.getState().push("success", t),
  error: (t: string) => useToastStore.getState().push("error", t),
};

export function ToastLayer() {
  const items = useToastStore((s) => s.items);
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-4 z-50 flex flex-col items-center gap-2">
      {items.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto max-w-sm rounded-full px-4 py-2 text-sm shadow-lg ${
            t.kind === "success"
              ? "bg-emerald-600 text-white"
              : t.kind === "error"
                ? "bg-rose-600 text-white"
                : "bg-slate-800 text-white"
          }`}
        >
          {t.text}
        </div>
      ))}
    </div>
  );
}
